export const INCREMENT_VALUE = 'CounterPage/INCREMENT_VALUE';
export const DECREMENT_VALUE = 'CounterPage/DECREMENT_VALUE';



// WEBPACK FOOTER //
// ./src/containers/CounterPage/constants.js